/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Like the pricing/billing drawers minus `favoriteUrl` — Review has no favourite row.
interface VisionDrawerState {
  isDrawerOpen: boolean
}

const initialState: VisionDrawerState = { isDrawerOpen: true }

const visionDrawerSlice = createSlice({
  name: 'visionDrawer',
  initialState,
  reducers: {
    setIsVisionDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isDrawerOpen = action.payload
    },
  },
})

export const { setIsVisionDrawerOpen } = visionDrawerSlice.actions

interface StateWithVisionDrawer {
  visionDrawer?: VisionDrawerState
}

export const selectIsOpenVisionDrawer = (state: StateWithVisionDrawer): boolean => state.visionDrawer?.isDrawerOpen ?? true

export default visionDrawerSlice.reducer
